import { render, staticRenderFns } from "./CommentApprovalModal.vue?vue&type=template&id=1b7a74af&"
import script from "./CommentApprovalModal.vue?vue&type=script&lang=js&"
export * from "./CommentApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommentApprovalModal.vue"
export default component.exports